import { EChatOperationActionTypes } from '../../actions/chatOperations';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function chatOperationsReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EChatOperationActionTypes.SetPending:
      return {
        ...state,
        chatWindow: {
          ...state.chatWindow,
          isChatOperationPending: action.payload,
        },
      };
    case EChatOperationActionTypes.AddToArchive: {
      const { chatList, chatWindow } = state;

      const removedFromArchiveChatId =
        chatList.removedFromArchiveChatId !== action.payload ? chatList.removedFromArchiveChatId : '';

      const removedFromSpamChatId =
        chatList.removedFromSpamChatId !== action.payload ? chatList.removedFromSpamChatId : '';

      /**
       * У пользователя может быть открыть какой-либо чат, но переместить в спам с помощью меню
       * он может любой другой чат, в таком случае текущий открытий чат закрывать не нужно.
       */
      const currentOpenedChatId =
        chatWindow.currentOpenedChatId !== action.payload ? chatWindow.currentOpenedChatId : '';

      return {
        ...state,
        chatList: {
          ...state.chatList,
          movedToArchiveChatIds: state.chatList.movedToArchiveChatIds.concat(action.payload),
          removedFromArchiveChatId,
          removedFromSpamChatId,
        },
        chatWindow: {
          ...state.chatWindow,
          currentOpenedChatId,
        },
      };
    }

    case EChatOperationActionTypes.AddToSpam: {
      const { chatList, chatWindow } = state;

      const removedFromArchiveChatId =
        chatList.removedFromArchiveChatId !== action.payload ? chatList.removedFromArchiveChatId : '';

      const removedFromSpamChatId =
        chatList.removedFromSpamChatId !== action.payload ? chatList.removedFromSpamChatId : '';

      /**
       * У пользователя может быть открыть какой-либо чат, но переместить в спам с помощью меню
       * он может любой другой чат, в таком случае текущий открытий чат закрывать не нужно.
       */
      const currentOpenedChatId =
        chatWindow.currentOpenedChatId !== action.payload ? chatWindow.currentOpenedChatId : '';

      return {
        ...state,
        chatList: {
          ...state.chatList,
          movedToSpamChatIds: state.chatList.movedToSpamChatIds.concat(action.payload),
          removedFromArchiveChatId,
          removedFromSpamChatId,
        },
        chatWindow: {
          ...state.chatWindow,
          currentOpenedChatId,
        },
      };
    }

    case EChatOperationActionTypes.RemoveFromArchive:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          movedToArchiveChatIds: state.chatList.movedToArchiveChatIds.filter(
            movedChatId => movedChatId !== action.payload,
          ),
          removedFromArchiveChatId: action.payload,
          removedFromSpamChatId: '',
        },
        chatWindow: {
          ...state.chatWindow,
          isChatOperationPending: false,
        },
      };

    case EChatOperationActionTypes.RemoveFromSpam:
      return {
        ...state,
        chatList: {
          ...state.chatList,
          movedToSpamChatIds: state.chatList.movedToSpamChatIds.filter(movedChatId => movedChatId !== action.payload),
          removedFromArchiveChatId: '',
          removedFromSpamChatId: action.payload,
        },
        chatWindow: {
          ...state.chatWindow,
          currentOpenedChatId: action.payload,
        },
      };

    default:
      return state;
  }
}
